// src/pages/InstagramPage.js
// Instagram feed integration — uses Instagram Basic Display API
// OR curated manual grid with product links
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

// ── CONFIGURATION ──────────────────────────────────────────────
// Option A: Instagram Basic Display API token
// Get from: developers.facebook.com → My Apps → Instagram Basic Display
// Note: Needs HTTPS & approved app
const INSTAGRAM_TOKEN = 'YOUR_INSTAGRAM_ACCESS_TOKEN_HERE';

// Option B: Your Instagram handle (for the follow CTA)
const INSTAGRAM_HANDLE = 'venkatagirihandlooms';

// ── CURATED POSTS (always shown as fallback / supplemental) ────
// Add your real Instagram image URLs and post links here
const CURATED_POSTS = [
  { id:1,  img:'https://images.unsplash.com/photo-1617627143233-1c3e1c33893c?w=600&q=80', likes:'2.4K', comments:'48', link:'#', caption:'Bridal Kanjivaram silk in pure gold zari — a dream draped in tradition ✨ #KanjivaramSaree #BridalSaree', type:'image', productSlug:'kanchi-cotton' },
  { id:2,  img:'https://images.unsplash.com/photo-1595274459742-4a41d35784f2?w=600&q=80', likes:'1.8K', comments:'32', link:'#', caption:'Pure silk in crimson & gold — woven by our master artisans over 5 days 🧵 #HandloomSaree #PureSilk', type:'image', productSlug:null },
  { id:3,  img:'https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?w=600&q=80', likes:'3.1K', comments:'67', link:'#', caption:'Pochampally Ikat — every diamond is woven with mathematical precision before a single thread crosses the loom 💫', type:'image', productSlug:null },
  { id:4,  img:'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=600&q=80', likes:'956',  comments:'21', link:'#', caption:'Our lightweight cotton handlooms — the perfect everyday saree 🌿 DM to order! #CottonSaree #HandloomIndia', type:'image', productSlug:'kanchi-cotton' },
  { id:5,  img:'https://images.unsplash.com/photo-1614252369475-531eba835eb1?w=600&q=80', likes:'2.2K', comments:'55', link:'#', caption:'Festival season is here! New arrivals in our Diwali silk collection 🪔 #DiwaliSaree #FestiveLook', type:'image', productSlug:null },
  { id:6,  img:'https://images.unsplash.com/photo-1609177028477-f1e7e2abe71c?w=600&q=80', likes:'1.5K', comments:'29', link:'#', caption:'Behind the loom — this one took our weaver 8 days to complete 🙏 #Handwoven #SlowFashion #Heritage', type:'image', productSlug:null },
  { id:7,  img:'https://images.unsplash.com/photo-1617627143233-1c3e1c33893c?w=600&q=80', likes:'4.2K', comments:'89', link:'#', caption:'Wedding season dispatch — 12 bridal sarees shipped this week! Every single one handwoven 💍 #BridalCollection', type:'image', productSlug:null },
  { id:8,  img:'https://images.unsplash.com/photo-1595274459742-4a41d35784f2?w=600&q=80', likes:'1.1K', comments:'18', link:'#', caption:'GI Tag certified — only authentic Venkatagiri handlooms 🏺 Shop link in bio! #GICertified #AuthenticHandloom', type:'image', productSlug:null },
  { id:9,  img:'https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?w=600&q=80', likes:'2.9K', comments:'44', link:'#', caption:'New arrival: Indigo ikat with natural dyes — limited pieces available 🌊 #NaturalDye #IkatSaree', type:'image', productSlug:null },
  { id:10, img:'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=600&q=80', likes:'1.3K', comments:'27', link:'#', caption:'Thank you @priyadarshni.s for this beautiful wedding photo! Glad our saree was part of your special day 💕', type:'image', productSlug:null },
  { id:11, img:'https://images.unsplash.com/photo-1614252369475-531eba835eb1?w=600&q=80', likes:'788',  comments:'14', link:'#', caption:'Monday motivation: A Venkatagiri saree a week keeps the average wardrobe away 😄 #SareeNotSorry', type:'image', productSlug:null },
  { id:12, img:'https://images.unsplash.com/photo-1609177028477-f1e7e2abe71c?w=600&q=80', likes:'3.4K', comments:'72', link:'#', caption:'Pure zari thread — 24 carat gold coated silver wire. This is what makes our sarees shimmer forever ✨ #ZariWork', type:'image', productSlug:null },
];

export default function InstagramPage() {
  const [posts,       setPosts]       = useState(CURATED_POSTS);
  const [activePost,  setActivePost]  = useState(null);
  const [apiLoaded,   setApiLoaded]   = useState(false);
  const [loading,     setLoading]     = useState(false);

  // Try Instagram Basic Display API
  useEffect(() => {
    if (INSTAGRAM_TOKEN.includes('YOUR_')) return;
    setLoading(true);
    fetch(`https://graph.instagram.com/me/media?fields=id,caption,media_type,media_url,thumbnail_url,permalink,timestamp,like_count,comments_count&access_token=${INSTAGRAM_TOKEN}&limit=24`)
      .then(r => r.json())
      .then(data => {
        if (data.data?.length) {
          const mapped = data.data
            .filter(p => p.media_type === 'IMAGE' || p.media_type === 'CAROUSEL_ALBUM')
            .map(p => ({
              id:       p.id,
              img:      p.media_url,
              likes:    p.like_count  ? `${p.like_count}`   : '—',
              comments: p.comments_count ? `${p.comments_count}` : '—',
              link:     p.permalink,
              caption:  p.caption || '',
              type:     'image',
              productSlug: null,
            }));
          setPosts(mapped);
          setApiLoaded(true);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const prev = () => {
    const i = posts.indexOf(activePost);
    if (i > 0) setActivePost(posts[i-1]);
  };
  const next = () => {
    const i = posts.indexOf(activePost);
    if (i < posts.length-1) setActivePost(posts[i+1]);
  };

  return (
    <div className="page">
      {/* ── HEADER ── */}
      <div style={{background:'linear-gradient(135deg,#833ab4,#fd1d1d,#fcb045)',position:'relative',overflow:'hidden',minHeight:200,display:'flex',alignItems:'center',justifyContent:'center'}}>
        <div style={{position:'absolute',inset:0,background:'rgba(0,0,0,0.35)'}}/>
        <div style={{position:'relative',zIndex:2,textAlign:'center',padding:'48px 24px'}}>
          <div style={{fontSize:10,letterSpacing:4,color:'rgba(255,255,255,0.8)',marginBottom:10,textTransform:'uppercase',fontFamily:"'Jost',sans-serif"}}>Follow Along</div>
          <h1 style={{fontFamily:"'Playfair Display',serif",fontSize:'clamp(2rem,5vw,3.5rem)',color:'#fff',fontStyle:'italic',marginBottom:12}}>
            <em>@{INSTAGRAM_HANDLE}</em>
          </h1>
          <p style={{fontFamily:"'Cormorant Garamond',serif",fontSize:17,color:'rgba(255,255,255,0.8)',marginBottom:24,fontStyle:'italic'}}>Daily saree stories, weaving reels & artisan spotlights</p>
          <a href={`https://www.instagram.com/${INSTAGRAM_HANDLE}`} target="_blank" rel="noopener noreferrer"
            style={{display:'inline-flex',alignItems:'center',gap:10,background:'rgba(255,255,255,0.15)',backdropFilter:'blur(8px)',border:'1.5px solid rgba(255,255,255,0.4)',color:'#fff',padding:'11px 28px',textDecoration:'none',fontFamily:"'Jost',sans-serif",fontSize:12,fontWeight:600,letterSpacing:1,textTransform:'uppercase'}}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
            Follow on Instagram
          </a>
        </div>
      </div>

      <div className="container" style={{padding:'48px 24px 72px'}}>

        {/* Stats bar */}
        <div style={{display:'flex',justifyContent:'center',gap:48,marginBottom:40,padding:'20px 0',borderBottom:'1px solid var(--border)',flexWrap:'wrap'}}>
          {[{n:'12K+',l:'Followers'},{n:'200+',l:'Posts'},{n:'4.8★',l:'Avg Engagement'}].map(s=>(
            <div key={s.l} style={{textAlign:'center'}}>
              <div style={{fontFamily:"'Playfair Display',serif",fontSize:28,color:'#7a1f1f',fontWeight:700}}>{s.n}</div>
              <div style={{fontFamily:"'Jost',sans-serif",fontSize:11,letterSpacing:2,textTransform:'uppercase',color:'#8a7968'}}>{s.l}</div>
            </div>
          ))}
        </div>

        {/* ── INSTAGRAM GRID ── */}
        {loading ? <div className="spinner"/> : (
          <>
            <div style={{marginBottom:16,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
              <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:'clamp(1.3rem,2.5vw,1.8rem)',color:'#7a1f1f',fontStyle:'italic'}}>
                Latest Posts
              </h2>
              {!apiLoaded && <span style={{fontSize:11,color:'#8a7968',fontFamily:"'Jost',sans-serif"}}>📸 Curated feed</span>}
            </div>

            <div className="insta-grid">
              {posts.map(post => (
                <div key={post.id} className="insta-cell" onClick={()=>setActivePost(post)}>
                  <img src={post.img} alt={post.caption?.slice(0,40)||''} onError={e=>{e.target.src='https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=400&q=60';}} style={{width:'100%',height:'100%',objectFit:'cover',display:'block'}}/>
                  <div className="insta-overlay">
                    <div className="insta-stats">
                      <span>❤️ {post.likes}</span>
                      <span>💬 {post.comments}</span>
                    </div>
                    {post.productSlug && <span style={{fontSize:10,background:'#7a1f1f',color:'#fff',padding:'3px 8px',fontFamily:"'Jost',sans-serif",letterSpacing:1}}>SHOP NOW</span>}
                  </div>
                </div>
              ))}
            </div>

            {/* Follow CTA */}
            <div style={{textAlign:'center',marginTop:32}}>
              <a href={`https://www.instagram.com/${INSTAGRAM_HANDLE}`} target="_blank" rel="noopener noreferrer"
                style={{display:'inline-flex',alignItems:'center',gap:8,border:'1.5px solid var(--border)',background:'#fff',color:'#2d1f1f',padding:'12px 28px',textDecoration:'none',fontFamily:"'Jost',sans-serif",fontSize:12,fontWeight:600,letterSpacing:1,textTransform:'uppercase'}}>
                View All on Instagram ↗
              </a>
            </div>

            {/* Shop the Look section */}
            {posts.some(p=>p.productSlug) && (
              <div style={{marginTop:64}}>
                <div style={{textAlign:'center',marginBottom:32}}>
                  <div className="section-subtitle">Spotted on Instagram</div>
                  <h2 className="section-title">Shop the Look</h2>
                  <div className="section-divider" style={{margin:'0 auto'}}/>
                </div>
                <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:24}}>
                  {posts.filter(p=>p.productSlug).slice(0,3).map(post=>(
                    <div key={post.id} style={{border:'1px solid var(--border)',background:'#fff',overflow:'hidden'}}>
                      <div style={{position:'relative',aspectRatio:'1',overflow:'hidden',cursor:'pointer'}} onClick={()=>setActivePost(post)}>
                        <img src={post.img} alt="" style={{width:'100%',height:'100%',objectFit:'cover',transition:'transform 0.4s'}}
                          onMouseEnter={e=>e.target.style.transform='scale(1.06)'} onMouseLeave={e=>e.target.style.transform='scale(1)'}/>
                        <div style={{position:'absolute',top:12,left:12,background:'#fff',padding:'3px 10px',fontSize:10,fontFamily:"'Jost',sans-serif",letterSpacing:1,color:'#7a1f1f',fontWeight:600}}>AS SEEN ON INSTAGRAM</div>
                      </div>
                      <div style={{padding:16}}>
                        <p style={{fontFamily:"'Cormorant Garamond',serif",fontSize:15,color:'#5a3a3a',lineHeight:1.6,marginBottom:12}}>{post.caption?.slice(0,80)}…</p>
                        <Link to={`/product/${post.productSlug}`} className="btn btn-outline" style={{fontSize:11,padding:'8px 18px'}}>Shop This Look →</Link>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </>
        )}

        {/* ── Setup Guide (shown when no API token) ── */}
        {INSTAGRAM_TOKEN.includes('YOUR_') && (
          <div style={{marginTop:48,padding:28,background:'#f7f0e6',border:'1px dashed #c9a84c'}}>
            <div style={{fontFamily:"'Jost',sans-serif",fontSize:11,letterSpacing:2,textTransform:'uppercase',color:'#c9a84c',marginBottom:8}}>Developer Note</div>
            <h3 style={{fontFamily:"'Cormorant Garamond',serif",fontSize:20,color:'#7a1f1f',marginBottom:12}}>Connect Your Real Instagram Feed</h3>
            <p style={{fontSize:13,color:'#5a3a3a',lineHeight:1.7,marginBottom:12}}>
              To show your live Instagram posts: <br/>
              1. Go to <strong>developers.facebook.com</strong> → Create App → Instagram Basic Display<br/>
              2. Add your Instagram account → Generate Access Token<br/>
              3. Replace <code>YOUR_INSTAGRAM_ACCESS_TOKEN_HERE</code> in InstagramPage.js<br/>
              4. The page will automatically load your real posts!
            </p>
            <p style={{fontSize:12,color:'#8a7968'}}>Currently showing curated demo posts. All images and product links are real once you add your token.</p>
          </div>
        )}
      </div>

      {/* ── POST LIGHTBOX ── */}
      {activePost && (
        <div className="modal-overlay" onClick={()=>setActivePost(null)}>
          <button className="modal-close" onClick={()=>setActivePost(null)}>✕</button>

          {/* Prev / Next */}
          <button onClick={e=>{e.stopPropagation();prev();}} style={{position:'fixed',left:20,top:'50%',transform:'translateY(-50%)',background:'rgba(255,255,255,0.15)',border:'none',color:'#fff',width:44,height:44,borderRadius:'50%',fontSize:24,cursor:'pointer',zIndex:10001,display:'flex',alignItems:'center',justifyContent:'center'}}>‹</button>
          <button onClick={e=>{e.stopPropagation();next();}} style={{position:'fixed',right:20,top:'50%',transform:'translateY(-50%)',background:'rgba(255,255,255,0.15)',border:'none',color:'#fff',width:44,height:44,borderRadius:'50%',fontSize:24,cursor:'pointer',zIndex:10001,display:'flex',alignItems:'center',justifyContent:'center'}}>›</button>

          <div style={{display:'grid',gridTemplateColumns:'1fr 320px',maxWidth:860,width:'94vw',background:'#fff',maxHeight:'90vh',overflow:'hidden'}} onClick={e=>e.stopPropagation()}>
            {/* Image */}
            <div style={{background:'#1a0f0f',display:'flex',alignItems:'center',justifyContent:'center'}}>
              <img src={activePost.img} alt="" onError={e=>{e.target.src='https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=600&q=60';}} style={{width:'100%',height:'100%',objectFit:'contain',maxHeight:'80vh'}}/>
            </div>
            {/* Info */}
            <div style={{display:'flex',flexDirection:'column',overflowY:'auto'}}>
              <div style={{padding:'16px 20px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:12}}>
                <div style={{width:36,height:36,borderRadius:'50%',background:'linear-gradient(135deg,#833ab4,#fd1d1d,#fcb045)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:18}}>🥻</div>
                <div>
                  <div style={{fontFamily:"'Jost',sans-serif",fontWeight:700,fontSize:13}}>@{INSTAGRAM_HANDLE}</div>
                  <div style={{fontSize:11,color:'#8a7968'}}>Venkatagiri Handlooms</div>
                </div>
              </div>
              <div style={{padding:'16px 20px',flex:1}}>
                <p style={{fontFamily:"'Cormorant Garamond',serif",fontSize:16,color:'#2d1f1f',lineHeight:1.7,marginBottom:16}}>{activePost.caption}</p>
                <div style={{display:'flex',gap:20,fontSize:14,color:'#5a3a3a',fontFamily:"'Jost',sans-serif",marginBottom:20}}>
                  <span>❤️ {activePost.likes}</span>
                  <span>💬 {activePost.comments}</span>
                </div>
                {activePost.productSlug && (
                  <Link to={`/product/${activePost.productSlug}`} onClick={()=>setActivePost(null)} className="btn btn-primary" style={{fontSize:11,width:'100%',justifyContent:'center'}}>Shop This Saree →</Link>
                )}
                <a href={activePost.link!=='#'?activePost.link:`https://instagram.com/${INSTAGRAM_HANDLE}`} target="_blank" rel="noopener noreferrer"
                  style={{display:'flex',alignItems:'center',justifyContent:'center',gap:6,marginTop:10,padding:'10px',border:'1px solid var(--border)',color:'#5a3a3a',textDecoration:'none',fontFamily:"'Jost',sans-serif",fontSize:11,letterSpacing:1,textTransform:'uppercase'}}>
                  View on Instagram ↗
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
